'use client';
import { Logo } from '@/components';
import { AnimatePresence, motion } from 'framer-motion';

export default function Loading() {
  return (
    <motion.div className="loading__wrapper">
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Logo />
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
}